export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'f95e300c-7fd8-46b1-a979-59a63ab990e2';
export const MODAL_CLOSE_SEC = 2.5;
